import {
  Card,
  CardContent,
  Divider,
  Grid,
  Skeleton,
  useMediaQuery,
} from "@mui/material";
import React from "react";

const LoanPlanSkeleton = () => {
  const isTablet = useMediaQuery("(max-width: 900px)");

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "4px !important",
        backgroundColor: "#F6F8F9",
        mb: 2,
        mx: 2,
      }}
    >
      <CardContent>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item md={7} xs={8} container spacing={2}>
            <Grid item>
              <Skeleton variant="circular" width={50} height={50} />
            </Grid>
            <Grid item>
              <Skeleton variant="text" width={150} height={30} />
              <Skeleton
                variant="rectangular"
                width={100}
                height={25}
                sx={{ mt: 1 }}
              />
            </Grid>
          </Grid>

          <Grid item xs={4} md={5} textAlign={"left"}>
            <Skeleton variant="text" width={180} height={25} />
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* مشخصات طرح - اسکلت نمونه‌ای */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Skeleton variant="text" width="100%" height={20} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Skeleton variant="text" width="100%" height={20} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Skeleton variant="text" width="100%" height={20} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Skeleton variant="text" width="100%" height={20} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default LoanPlanSkeleton;
